module.exports = __webpack_public_path__ + "img/app_key.e9739958.png";